import type { AnyAction } from "redux";
import { OVERRIDE_PRIMARY_NAV } from "../../action_types/primary_nav_override_action_types";
import { swSettings } from "app/common/services/swSettings";

export enum PrimaryNavOverrideMode {
    All = "all",
    Legacy = "legacy",
    S1 = "s1",
    S2 = "s2",
    S25 = "s25",
}

interface PrimaryNavOverrideState {
    navOverrideMode: PrimaryNavOverrideMode;
}

const getDefaultState = (): PrimaryNavOverrideState => {
    return {
        navOverrideMode: swSettings?.user?.isSimilarWebUser ? PrimaryNavOverrideMode.S25 : PrimaryNavOverrideMode.S2,
    };
};

const handlers: Record<string, (state: PrimaryNavOverrideState, action: AnyAction) => PrimaryNavOverrideState> = {
    [OVERRIDE_PRIMARY_NAV]: (state, action) => {
        return { navOverrideMode: action.payload };
    },
};

const primaryNavOverrideReducer = (state = getDefaultState(), action: AnyAction) => {
    const handler = handlers[action.type];

    if (handler) {
        return handler(state, action);
    }

    return state;
};

export default primaryNavOverrideReducer;
